var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutorenewDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "#999490",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 20 20)",
    id: "97834f79-0362-45fb-9a44-dd8186abc77b"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(153,148,144)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-20, -20.04)",
    d: "M 8.29199 26.375 C 7.70866 25.375 7.29199 24.3473 7.04199 23.292 C 6.79199 22.236 6.66699 21.1663 6.66699 20.083 C 6.66699 16.4163 7.97233 13.2707 10.583 10.646 C 13.1943 8.02067 16.3333 6.708 20 6.708 L 21.292 6.708 L 18.167 3.625 L 20.042 1.75 L 26.417 8.125 L 20.042 14.458 L 18.167 12.583 L 21.25 9.5 L 20 9.5 C 17.0833 9.5 14.5973 10.5347 12.542 12.604 C 10.486 14.6733 9.45799 17.1663 9.45799 20.083 C 9.45799 20.861 9.53466 21.604 9.68799 22.312 C 9.84066 23.0207 10.042 23.7083 10.292 24.375 L 8.29199 26.375 Z M 19.917 38.333 L 13.542 31.958 L 19.917 25.625 L 21.75 27.458 L 18.667 30.583 L 20 30.583 C 22.9167 30.583 25.4027 29.5483 27.458 27.479 C 29.514 25.4097 30.542 22.9167 30.542 20 C 30.542 19.222 30.4723 18.479 30.333 17.771 C 30.1943 17.0623 29.9723 16.3747 29.667 15.708 L 31.708 13.708 C 32.264 14.708 32.674 15.736 32.938 16.792 C 33.2013 17.8473 33.333 18.9167 33.333 20 C 33.333 23.6667 32.0277 26.8127 29.417 29.438 C 26.8057 32.0627 23.6667 33.375 20 33.375 L 18.667 33.375 L 21.75 36.458 L 19.917 38.333 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.38 0.38 -0.02 0.02 20 20)",
    id: "914e248a-d860-4900-9018-70a96e343e8a"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(153,148,144)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(101,101,101)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-50, -50)",
    d: "M 90.375 67.209 L 9.625 67.209 L 9.625 32.792 L 90.375 32.792 L 90.375 67.209 z M 11.625 65.209 L 88.375 65.209 L 88.375 34.792 L 11.625 34.792 L 11.625 65.209 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorenewDisabled);
export default __webpack_public_path__ + "static/media/autorenewDisabled.a80f7d21c0cd12956b0c9ecac3835927.svg";
export { ForwardRef as ReactComponent };